<!-- Content -->
@if (slideAuthorFacade.currentSelectedSlideAnnotation$ | async; as annotation) {
  <div
    class="flex flex-column align-items-center">
    <!-- POIs -->
    @if (slideAuthorFacade.poiIdsByAnnotation$(annotation.id) | async; as poiIds) {
      <medsurf-design-input-multi-select
        [name]="'annotation_pois'"
        [label]="'global.pois'"
        [model]="poiIds"
        [options]="(slideAuthorFacade.currentSelectedSlidePoisArray$ | async) || []"
        [class]="'w-full'"
        [labelIcon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"
      (valueChange)="onChange($event)"></medsurf-design-input-multi-select>
    }
  </div>
}
